export default __webpack_public_path__ + "static/media/rtist-logo.eb9265f1.jpg";